import createSvgIcon from '../Utils/CreateSvgIcon';

export const France = createSvgIcon(
  <>
    <path d="M20 0v16h-6.667V0z" fill="#C7270A" />
    <path d="M13.333 0v16H6.668V0z" fill="#fff" />
    <path d="M6.666 0v16H0V0z" fill="#052962" />
  </>,
  'France',
  '-2 -4 24 24',
);
